import { t } from "i18next";
import classNames from "classnames";
import {
  IWebsiteBuilderElementBase,
  IWebsiteBuilderElementDataBase,
  IWebsiteBuilderElementDesignStyles,
  TWebsiteBuilderElement,
} from "./websiteBuilderElement";

export type TWebsiteBuilderInputType = "text" | "email" | "date" | "number" | "phone-number";

export interface IWebsiteBuilderInputSettings {
  type: TWebsiteBuilderInputType;
  required: boolean;
  label: string;
  placeholder: string;
}

export interface IWebsiteBuilderInputData extends IWebsiteBuilderElementDataBase {
  type: "input";
  settings: IWebsiteBuilderInputSettings;
}

export interface IWebsiteBuilderInput extends IWebsiteBuilderElementBase {
  element: IWebsiteBuilderInputData;
}

export function isWebsiteBuilderInput(node: TWebsiteBuilderElement): node is IWebsiteBuilderInput {
  return node?.element?.type === "input";
}

export function generateDefaultInput(): IWebsiteBuilderInput {
  return {
    id: crypto.randomUUID(),
    type: "element",
    element: {
      type: "input",
      position: { x: 0, y: 0 },
      dimensions: { width: 150, height: 50 },
      zIndex: null,
      settings: {
        type: "text",
        required: false,
        label: t("Label"),
        placeholder: t("Placeholder"),
      },
    },
  };
}

interface IWebsiteBuilderInputDesignStyles extends IWebsiteBuilderElementDesignStyles {
  labelClassName: string;
  labelContentClassName: string;
}

export function generateInputDesignStyles(settings: IWebsiteBuilderInputSettings): IWebsiteBuilderInputDesignStyles {
  return {
    labelClassName: "website-builder-input-label",
    labelContentClassName: classNames("website-builder-input-label-content", {
      "input-required": settings.required,
    }),
    className: "website-builder-input",
    style: {},
  };
}
